import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "notif-card__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = ["onKeydown"]
const _hoisted_3 = { class: "notif-card__head" }
const _hoisted_4 = { class: "notif-card__title" }
const _hoisted_5 = { class: "notif-card__time" }

import { computed } from 'vue';
import {
  Bell,
  CalendarClock,
  CalendarDays,
  CreditCard,
  LifeBuoy,
  UserCheck,
  X,
} from 'lucide-vue-next';
import type { RawNotification } from '@/shared/types/notification';

// `expanded` (баг 5.2) — раскрыта ли карточка в режиме просмотра содержимого;
// управляется родителем (страница/дропдаун), по умолчанию свёрнута.

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationCard',
  props: {
    notification: {},
    expanded: { type: Boolean }
  },
  emits: ["act", "dismiss", "open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const ICON_BY_CATEGORY = {
  bookings: CalendarClock,
  events: CalendarDays,
  mentor_app: UserCheck,
  payments: CreditCard,
  support: LifeBuoy,
  other: Bell,
};

const stripHtml = (value: string): string =>
  value.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();

const icon = computed(() =>
  ICON_BY_CATEGORY[props.notification.category] ?? ICON_BY_CATEGORY.other
);

const fallbackTitle = computed(() => 'Уведомление');
const fallbackBody = computed(() =>
  stripHtml(props.notification.message ?? ''),
);
const displayTitle = computed(() =>
  stripHtml(props.notification.title || fallbackTitle.value),
);
const displayBody = computed(() =>
  stripHtml(props.notification.body || fallbackBody.value),
);

const canDismiss = computed(() =>
  !['acted', 'dismissed', 'expired'].includes(props.notification.status),
);

const relativeTime = computed(() => {
  const ts = new Date(props.notification.created_at).getTime();
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60_000);
  if (m < 1) return 'только что';
  if (m < 60) return `${m} мин назад`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ч назад`;
  const d = Math.floor(h / 24);
  return `${d} дн назад`;
});

function onCtaClick() {
  if (!props.notification.cta) return;
  emit('act', props.notification.public_id, props.notification.cta.href);
}

function onBodyClick() {
  emit('open', props.notification.public_id);
}

function onDismissClick() {
  emit('dismiss', props.notification.public_id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["notif-card", [
      `notif-card--${_ctx.notification.kind ?? 'info'}`,
      `notif-card--priority-${_ctx.notification.priority}`,
      `notif-card--status-${_ctx.notification.status}`,
      `notif-card--category-${_ctx.notification.category || 'other'}`,
    ]])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "notif-card__indicator",
      "aria-hidden": true
    }, null, -1)),
    _createElementVNode("span", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), { size: 20 }))
    ]),
    _createElementVNode("div", {
      class: "notif-card__main",
      role: "button",
      tabindex: "0",
      onClick: onBodyClick,
      onKeydown: [
        _withKeys(onBodyClick, ["enter"]),
        _withKeys(_withModifiers(onBodyClick, ["prevent"]), ["space"])
      ]
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("strong", _hoisted_4, _toDisplayString(displayTitle.value), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(relativeTime.value), 1)
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["notif-card__body", { 'notif-card__body--expanded': _ctx.expanded }])
      }, _toDisplayString(displayBody.value), 3),
      (_ctx.notification.cta)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "notif-card__cta",
            onClick: _withModifiers(onCtaClick, ["stop"])
          }, _toDisplayString(_ctx.notification.cta.label), 1))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2),
    (canDismiss.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "notif-card__dismiss",
          "aria-label": 'Скрыть уведомление',
          onClick: _withModifiers(onDismissClick, ["stop"])
        }, [
          _createVNode(_unref(X), {
            size: 18,
            "aria-hidden": "true"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})